import { useTable } from '@refinedev/antd';
import apiEndpoint from 'core/common/apiEndPoints';
import regex from 'core/constants/Regex';

const RuleList = ({
  groupId,
  appliedFilters,
  pageType,
  isPublished,
  renderRules,
  onReady,
}) => {
  const resourceBase =
    pageType === 'Show' && isPublished
      ? apiEndpoint.rules
      : apiEndpoint.rulesDraft;

  let resource = `${resourceBase}/?rule_group=${groupId}`;

  if (appliedFilters?.name) {
    resource += `&rule_name__contains=${appliedFilters.name}`;
  }
  if (appliedFilters?.status?.length === 1) {
    const isActive = appliedFilters.status[0] === 'Active';
    resource += `&rule_is_active=${isActive ? 'True' : 'False'}`;
  }
  if (appliedFilters?.dynamic) {
    Object.entries(appliedFilters.dynamic).forEach(([, values]) => {
      if (Array.isArray(values) && values.length > 0) {
        values.forEach((val) => {
          const cleanedVal =
            typeof val === 'string'
              ? val.replace(regex.whitespaceCheck, '')
              : val;
          resource += `&rule_filter=${cleanedVal}`;
        });
      }
    });
  }

  const { tableProps, tableQueryResult } = useTable({
    resource,
    pagination: { mode: 'server' },
  });
  onReady?.(tableQueryResult.refetch);
  const rawData: any = tableProps?.dataSource;
  const rules = Array.isArray(rawData?.results) ? rawData.results : [];
  return renderRules({ rules, tableProps });
};

export default RuleList;
